import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { SKILLS_DATA } from '../../constants';
import SkillGroup from './SkillGroup';
import content from '../../i18n/content';
import './Skills.css';

const GROUP_ORDER = ['languages', 'frontend', 'backendCloud', 'aiCore'];

export default function SkillsSection() {
  const { lang } = useLanguage();
  const t = content[lang].skills;

  return (
    <section id="skills" className="skills-section">
      <h2>{t.sectionTitle}</h2>
      <div className="skills-grid">
        {GROUP_ORDER.map((key) => (
          <SkillGroup key={key} title={t.groups[key]} items={SKILLS_DATA[key]} />
        ))}
      </div>
    </section>
  );
}
